module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  components:
    'cookie-accept':    require('../cookie_accept')
    'partners-slider':  require('../partners_slider')

  computed:

    windowWidth: ->
      @.$store.state.window.width

    cookieAcceptHidden: ->
      @.$store.state.cookie.cookies['kgm-cookie-accept-hidden']

    partners: ->
      @.$store.state.partners.partners

  methods:

    updateCalculatedHeight: ->
      @.$store.dispatch('window/updateFooterSpacerHeight', { height: @.$el.clientHeight })

    onPartnersSliderBoundingUpdated: ->
      @.$nextTick => @updateCalculatedHeight()

  watch:

    windowWidth: ->
      @updateCalculatedHeight()

    cookieAcceptHidden: ->
      @.$nextTick => @updateCalculatedHeight()

    partners: ->
      @.$nextTick => @updateCalculatedHeight()



// WEBPACK FOOTER //
// ./assets/js/frontend/components/page_bottom_static_container/index.coffee